export const OPPORTUNITY_DELETION_JUSTIFICATION_OPTIONS = [
  'Loja não existe (Fechada)',
  'Suspeita de Fraude',
  'Grupo já atendido pelo Santander',
  'CNPJ possui outro ramo de atividade',
  'Outros'
] as const

export const OPPORTUNITY_DELETION_OTHER_VALUE =
  OPPORTUNITY_DELETION_JUSTIFICATION_OPTIONS[OPPORTUNITY_DELETION_JUSTIFICATION_OPTIONS.length - 1]

export type OpportunityDeletionJustificationOption =
  (typeof OPPORTUNITY_DELETION_JUSTIFICATION_OPTIONS)[number]

export type OpportunityDeletionAttachment = {
  file_name: string
  storage_file_name: string
  url: string
  created_at: string
  size: number
  extension: string
}

export type OpportunityDeletionSubmitData = {
  reason: OpportunityDeletionJustificationOption
  description?: string
  attachments: OpportunityDeletionAttachment[]
}

export type OpportunityDeletionModalProps = {
  isOpen: boolean
  opportunityName?: string
  onClose(): void
  onSubmit(data: OpportunityDeletionSubmitData): Promise<void> | void
  isSubmitting: boolean
}
